import styled from "styled-components";
import { background, space } from "styled-system";
export const InfoMessageContainer = styled.div `
  border-radius: 0.75rem;
  border: ${({ alert }) => alert ? "none" : "1px solid #E3E3E3"};
  background-color: ${({ alert }) => alert ? "rgba(246, 197, 68, 0.40)" : "none"};
  box-sizing: border-box;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  ${background}
  ${space}
`;
